import { AbstractMermaidTokenBuilder } from '../common/index.js';

export class PacketTokenBuilder extends AbstractMermaidTokenBuilder {
  public constructor() {
    super(['packet']);
  }
}
